import { Fragment, useEffect, useState } from "react";
import { Input, Pagination, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import BoxCompany from "./components/BoxCompany";

import { EmptyComponent } from "@/components/ui/EmptyComponent";
import { LoadingComponent } from "@/components/ui/LoadingComponent";
import CompanyService from "@/services/CompanyService";
import PropertiesService from "@/services/PropertiesService";

const Company = () => {

    const [loading, setLoading] = useState(true);
    const [filterLocation, setFilterLocation] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [searchLocation, setSearchLocation] = useState("");
    const [location, setLocation] = useState('');
    const [filterSearch, setFilterSearch] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [query, setQuery] = useState({});

    useEffect(() => {
        PropertiesService.getFilter({ ParentCode: "J003"}).then((res) => {
            setFilterLocation((
                [
                    {
                        Code: "",
                        Name: "Tât cả Tỉnh/Thành",
                    },
                    ...res.Data,
                ]
            ));
        }).catch((err) => {
            console.error(err)
        })
    }, [])

    useEffect(() => {
        setFilterSearch(
            filterLocation.filter((location) =>
                location.Name.toLowerCase().includes(searchLocation.toLowerCase())
            )
        );

    }, [searchLocation, filterLocation]);

    const handleSubmit = () => {
        const temp = {};

        if (location) temp.locationId = location;
        if (searchText) temp.inputSearch = searchText;


        setQuery(temp);
    }
    useEffect(() => {
        CompanyService.getCompany(query).then((res) => {
            setCompanies(res)
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        })
    }, [query]);


    if (loading) {
        return <LoadingComponent />
    }
    return (
        <div
            className="container xl:container flex flex-col mx-auto p-4 lg:p-8">
            <div className={"flex justify-between border border-b-0 rounded-t-xl overflow-hidden border-gray-200"}>
                <div
                    className={
                        "w-full rounded-t-xl p-5 bg-gradient-to-tl from-green-400 via-green-500 to-green-700 animate-gradient"
                    }
                    style={{
                        backgroundSize: "200% 200%",
                        animation: "gradient-animation 6s ease infinite",
                    }}
                >      
                    <h1 className={"text-3xl text-white font-bold "}>Tìm công ty</h1>
                    <div className={"text-white"}>Lựa chọn thông tin và công việc phù hợp ở các công ty</div>
                </div>
            </div>

            <div className="w-full bg-gradient-to-b from-gray-200 to-gray-0 flex justify-center rounded-bl-lg rounded-br-lg border border-t-0 border-gray-200
          gap-2 p-2
          flex-wrap lg:flex-nowrap lg:p-4">
                <div className=" w-full flex gap-2 flex-col md:flex-row">
                    <Input
                        variant="outlined"
                        prefix={<SearchOutlined className="text-gray-400" />}
                        placeholder="Nhập từ khóa tìm kiếm"
                        className="w-full md:w-2/3  h-12 text-base"
                        value={searchText}
                        onChange={e => setSearchText(e.target.value)}
                    />

                    <div className="w-full md:w-1/3 h-12">
                        <Select
                            onChange={(e) => setLocation(e)}
                            placeholder="Tỉnh/Thành"
                            value={location}
                            fieldNames={{ value: 'Code', label: 'Name' }}
                            optionFilterProp={'Name'}
                            options={filterSearch}
                            dropdownRender={(menu) => (
                                <div>
                                    <div className="p-2 ">
                                        <Input
                                            className="p-2"
                                            placeholder="Tìm kiếm"
                                            value={searchLocation}
                                            onChange={(e) => setSearchLocation(e.target.value)}
                                        />
                                    </div>
                                    <div>{menu}</div>
                                </div>
                            )}
                            style={{ width: "100%", height: "100%" }}

                            notFoundContent={
                                <div className="text-red-500 text-center">
                                    Không tìm thấy Tỉnh/Thành "{searchLocation}"
                                </div>
                            }

                        />
                    </div>
                </div>
                <button
                    type="primary"
                    className=" w-full h-12 px-8 bg-primary hover:bg-primary-hover rounded-lg text-white font-semibold border-none text-base transition-all
                            lg:w-1/4"
                    onClick={handleSubmit}
                >
                    Tìm Kiếm
                </button>
            </div>

            <div className="p-3 lg:p-4 mt-2 rounded-lg shadow-lg lg:border-2 lg:border-gray-200">
                <div className="flex flex-col gap-2 lg:flex-row  lg:items-center  justify-between">
                    <div className="text-2xl font-medium">
                        Công ty nổi bật <span className="text-gray-500">({companies.length})</span>
                    </div>
                </div>

                <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6 ">
                    {companies.map(company => (
                        <Fragment key={company.Pk}><BoxCompany data={company} /></Fragment>
                    ))}
                </div>

                {companies.length === 0 && (
                    <EmptyComponent description={"công ty"} />

                )}

                <div className="flex items-center justify-center mt-8">
                    <Pagination
                        responsive={true}
                        defaultCurrent={1}
                        total={companies.length}
                        pageSize={6}
                        showSizeChanger={false}
                        hideOnSinglePage
                    />
                </div>
            </div>

        </div>
    );
};

export default Company;
